import Icon, { IconProps, IconSize } from '@douyinfe/semi-icons';

export type { IconProps, IconSize };

export default Icon;